import React from 'react';
import cx from 'classnames';
import SVGBlock from '../../../App/svg/SVGBlock';
import { get } from 'lodash';
import Flip from './flip';
import { describeArc } from './util';
import * as d3Time from 'd3-time';
import * as d3 from 'd3';
import MobileDetect from 'mobile-detect';
import MediaQuery from 'react-responsive';
import Loader from '../../../Loader';

const md = new MobileDetect(window.navigator.userAgent);
const isMobile = !!md.mobile();

export default class RenderConfigurationSVG extends React.Component {
  height = 350;
  width = Math.min(950, window.innerWidth - 80);
  door = 36;

  state = {
    svgRacks: false,
    saving: false
  };

  componentDidMount() {
    this.getTemplate();
  }
  componentDidUpdate(prevProps) {
    if (this.props.parameters.savePdf && !prevProps.parameters.savePdf) {
      this.savePdf();
    }
  }

  template = { __html: '' };
  getTemplate = () => {
    d3.text('/assets/pdf/templates/Go_Configure_PDF_Template_Size_A.svg').then(
      (res) => {
        this.template = { __html: res };
        this.forceUpdate();
      }
    );
  };

  ftIn = (inches) => {
    return Math.floor(inches / 12) + "'-" + Math.ceil(inches % 12) + '"';
  };

  get scale() {
    const {
      configuration: {
        dim: { length, width, walkway },
        types: { top, bottom, fields }
      },
      title
    } = this.props;
    if (width > 2688 || length > 1536) {
      return {
        text: '1/256',
        inch: `3/64" = 1' - 0"`,
        scalar: eval(1 / 256)
      };
    }
    if (width > 1344 || length > 768) {
      return {
        text: '1/384',
        inch: `1/32" = 1' - 0"`,
        scalar: eval(1 / 384)
      };
    }
    if (width > 896 || length > 512) {
      return {
        text: '1/192',
        inch: `1/16" = 1' - 0"`,
        scalar: eval(1 / 192)
      };
    }
    if (width > 672 || length > 384) {
      return {
        text: '1/128',
        inch: `3/32" = 1' - 0"`,
        scalar: eval(1 / 128)
      };
    }
    if (width > 336 || length > 192) {
      return {
        text: '1/96',
        inch: `1/8" = 1' - 0"`,
        scalar: eval(1 / 96)
      };
    }
    return {
      text: '1/48',
      inch: `1/4" = 1' - 0"`,
      scalar: eval(1 / 48)
    };
  }

  savePdf = () => {
    const { height, door, scale, ftIn } = this;
    const {
      configuration: {
        dim: { length, width, walkway },
        types: { top, bottom, fields }
      },
      title
    } = this.props;

    const m = Math.min(height / length, this.width / width);
    const sc = this.scale.scalar / m;
    const screenWidth = Math.round(m * width);
    const screenHeight = Math.round(m * length);
    const paperWidth = 11;
    const xOffset = 1.5;
    const yOffset = 3;
    let xOffsetSm = 1;
    let yOffsetSm = 2;

    const { jsPDF, svg2pdf } = window;
    // const { width, height } = this.props;
    const svgElement = document.getElementById('svg-container');
    const svgTemplate = document.getElementById('svg-template');
    // create a new jsPDF instance
    const pdf = new jsPDF('l', 'in', [11, 8.5]);

    // var imgData = 'data:image/png;base64,' + Base64.encode('/assets/img/thumbs/configuration_balanced.png');
    // console.log(imgData);
    const generatePDF = (img) => {
      pdf.advancedAPI((pdf) => {
        const fontSize = 12;
        const textX = xOffsetSm + 0.5;
        pdf.setFontSize(fontSize);

        pdf.text(`Scale: ${this.scale.inch}`, textX + 0, yOffsetSm, {});
        pdf.text(
          `Room Size: ${ftIn(width)} x ${ftIn(length)}`,
          textX + 0,
          yOffsetSm + 0.2,
          {}
        );
        pdf.text(
          `Bikes: ${top.count * 2 + this.bottomCount * 2} total`,
          textX + 0,
          yOffsetSm + 0.4,
          {}
        );
        pdf.setLineWidth(0.01);
        const lineMargin = 0.06;
        // pdf.line(
        //   textX,
        //   yOffsetSm + lineMargin,
        //   textX + 1,
        //   yOffsetSm + lineMargin
        // );
        // pdf.line(textX, yOffsetSm, textX, yOffsetSm + lineMargin * 2);
        // pdf.line(textX + 1, yOffsetSm, textX + 1, yOffsetSm + lineMargin * 2);
        // const tickLength = 0.03;
        // pdf.line(
        //   textX + 1 - tickLength,
        //   yOffsetSm + lineMargin + tickLength,
        //   textX + 1 + tickLength,
        //   yOffsetSm + lineMargin - tickLength
        // );
        // pdf.line(
        //   textX - tickLength,
        //   yOffsetSm + lineMargin + tickLength,
        //   textX + tickLength,
        //   yOffsetSm + lineMargin - tickLength
        // );

        pdf.setFontSize(fontSize * 0.7);

        const timeFormat = d3.timeFormat('%m/%d/%Y');
        pdf.text(timeFormat(new Date()), 2.05, 7.5, {
          align: 'center'
        });

        yOffsetSm += 0.6;

        // pdf.text(title, xOffsetSm, yOffsetSm, { baseline: 'ideographic' });
        // yOffsetSm += 0.5;
        // pdf.text(
        //   `Room size: ${ftIn(width)}" x ${ftIn(length)}"`,
        //   xOffsetSm,
        //   yOffsetSm,
        //   { baseline: 'ideographic' }
        // );
        // yOffsetSm += 0.5;
        // pdf.text(`${top.count * 2} above walkway`, xOffsetSm, yOffsetSm, {
        //   baseline: 'ideographic'
        // });
        // yOffsetSm += 0.5;
        // pdf.text(
        //   `${this.bottomCount * 2} above walkway`,
        //   xOffsetSm,
        //   yOffsetSm,
        //   {
        //     baseline: 'ideographic'
        //   }
        // );
        // yOffsetSm += 0.5;
        // pdf.text(
        //   `${top.count * 2 + this.bottomCount * 2} bikes total`,
        //   xOffsetSm,
        //   yOffsetSm,
        //   { baseline: 'ideographic' }
        // );
        // yOffsetSm += 1;

        const small = Math.min(width * scale.scalar, length * scale.scalar);
        const large = Math.max(width * scale.scalar, length * scale.scalar);
        const x =
          (width * scale.scalar === small ? 0 : (large - small) / 2) + xOffset;
        const y =
          (length * scale.scalar === small ? 0 : (large - small) / 2) +
          yOffsetSm;
        pdf.addImage(img, 'JPEG', x, y, small, small);
        // render the svg element
        svgTemplate &&
          svg2pdf(svgTemplate, pdf, {
            xOffset: 0,
            yOffset: 0,
            scale: 0.014
          });

        // render the svg element

        svg2pdf(svgElement, pdf, {
          xOffset,
          yOffset: yOffsetSm,
          scale: sc
        });

        // get the data URI
        const uri = pdf.output('datauristring');

        // console.log(uri)

        // or simply safe the created pdf
        // pdf.save('mypdf.pdf', {});
        pdf.save({ filename: 'GoConfigure_Export.pdf' });
        this.setState({ svgRacks: false, saving: false });
        this.props.actions.savePdfOff();
      });
    };

    function getImgFromUrl(logo_url) {
      var img = new Image();
      img.src = logo_url;
      img.onload = function() {
        generatePDF(img);
      };
    }
    setTimeout(() => {
      this.setState({ svgRacks: true }, () =>
        setTimeout(
          () => getImgFromUrl('/assets/img/watermark/gcs_water.jpg'),
          0
        )
      );
    }, 0);

    // doc.setFontSize(40);
    // doc.text(30, 20, 'Hello world!');
    // doc.addImage(imgData, 'JPEG', 15, 40, 180, 160);
    // doc.output('datauri');
  };

  render() {
    const { ftIn } = this;
    const { height, door } = this;
    const { svgRacks, saving } = this.state;
    const {
      parameters: { bikeConfiguration },
      configuration: {
        dim: { length, width, walkway },
        types: { top, bottom, fields }
      },
      pseudoKey,
      title,
      explainerText
    } = this.props;

    const m = Math.min(height / length, this.width / width);
    const screenWidth = Math.round(m * width);
    const screenHeight = Math.round(m * length);
    const isFields = fields && fields.fields * fields.count > bottom.count;
    this.bottomCount = fields
      ? Math.max(fields.fields * fields.count, bottom.count)
      : bottom.count;

    return (
      <div
        className='result-container'
        style={{ marginBottom: explainerText ? 90 : null }}
      >
        <div className='metadata-configuration'>
          {/* <strong>{title}</strong> */}
          <div>
            Room size: {ftIn(width)}" x {ftIn(length)}"
          </div>
          {/* <div>{top.count * 2} above walkway</div>
          <div>{this.bottomCount * 2} below walkway</div> */}
          <div>{top.count * 2 + this.bottomCount * 2} bikes total</div>
          {!isMobile && (
            <button
              className={cx({ saving: this.state.saving })}
              onClick={() => {
                this.setState({ saving: true }, () => {
                  this.props.actions.savePdfOn();
                });
              }}
            >
              {this.state.saving ? 'Building' : 'Save'} PDF
              {this.state.saving && <Loader />}
            </button>
          )}
        </div>
        <div
          style={{ display: 'none' }}
          dangerouslySetInnerHTML={this.template}
        />
        <svg
          version='1.1'
          width={screenWidth + 'px'}
          height={screenHeight + 'px'}
          overflow='visible'
          preserveAspectRatio='xMinYMin meet'
          shapeRendering='optimizeSpeed'
          id='svg-container'
          style={{
            fill: 'none',
            overflow: 'visible',
            stroke: 'black',
            strokeWidth: 1,
            fill: 'none'
          }}
        >
          <g>
            <rect
              x={0}
              y={0}
              width={screenWidth}
              height={screenHeight}
              className='svg-transition'
              style={{ fill: 'none', stroke: 'black', strokeWidth: 1 }}
            />
            <path
              d={`M0 ${top.dim.depth * m} L${screenWidth} ${top.dim.depth * m}`}
              className='svg-transition'
              style={{
                fill: 'none',
                stroke: 'black',
                strokeDasharray: 4
              }}
            />
            <g transform={`translate(50 ${top.dim.depth * m})`}>
              <path
                transform={`translate(5 ${5 + (walkway / 2) * m})`}
                d='M6.23-8.33L5.08-8.33Q4.87-9.82 3.75-9.82L3.75-9.82Q2.78-9.82 2.25-8.64L2.25-8.64Q1.76-7.54 1.74-5.66L1.74-5.66Q2.54-6.82 3.77-6.82L3.77-6.82Q4.80-6.82 5.51-6.06L5.51-6.06Q6.35-5.18 6.35-3.74L6.35-3.74Q6.35-2.54 5.78-1.64L5.78-1.64Q5.00-0.44 3.58-0.44L3.58-0.44Q2.30-0.44 1.52-1.61L1.52-1.61Q0.70-2.91 0.70-5.20L0.70-5.20Q0.70-7.63 1.42-9.13L1.42-9.13Q2.25-10.79 3.73-10.79L3.73-10.79Q5.76-10.79 6.23-8.33L6.23-8.33ZM3.60-5.91L3.60-5.91Q2.78-5.91 2.29-5.17L2.29-5.17Q1.91-4.58 1.91-3.70L1.91-3.70Q1.91-2.91 2.18-2.35L2.18-2.35Q2.65-1.40 3.61-1.40L3.61-1.40Q4.38-1.40 4.85-2.10L4.85-2.10Q5.27-2.71 5.27-3.71L5.27-3.71Q5.27-4.62 4.91-5.20L4.91-5.20Q4.46-5.91 3.60-5.91ZM10.50-10.79L10.50-10.79Q13.22-10.79 13.22-5.61L13.22-5.61Q13.22-0.43 10.50-0.43L10.50-0.43Q7.79-0.43 7.79-5.61L7.79-5.61Q7.79-10.79 10.50-10.79ZM9.13-3.18L9.13-3.18L11.63-8.89Q11.24-9.83 10.49-9.83L10.49-9.83Q8.93-9.83 8.93-5.61L8.93-5.61Q8.93-4.18 9.13-3.18ZM11.87-8.04L9.37-2.35Q9.75-1.39 10.50-1.39L10.50-1.39Q12.07-1.39 12.07-5.63L12.07-5.63Q12.07-7.03 11.87-8.04L11.87-8.04ZM15.08-10.02L15.08-11.73L16.84-11.73L16.84-10.78Q16.84-9.17 15.60-7.92L15.60-7.92L14.75-7.92Q15.74-8.88 15.85-10.02L15.85-10.02L15.08-10.02ZM17.88-10.02L17.88-11.73L19.65-11.73L19.65-10.78Q19.65-9.17 18.40-7.92L18.40-7.92L17.55-7.92Q18.55-8.88 18.66-10.02L18.66-10.02L17.88-10.02Z'
                style={{ fill: 'black', stroke: 'none' }}
              />
              <path
                d={`M0 ${0} L0 ${walkway * m}`}
                className='svg-transition'
                style={{
                  fill: 'none',
                  stroke: 'black'
                }}
              />
              <path
                d={`M-2 ${-2} L2 ${2}`}
                className='svg-transition'
                style={{
                  fill: 'none',
                  stroke: 'black'
                }}
              />
              <path
                d={`M-2 ${walkway * m - 2} L2 ${walkway * m + 2}`}
                className='svg-transition'
                style={{
                  fill: 'none',
                  stroke: 'black'
                }}
              />
            </g>
            <path
              d={`M0 ${(top.dim.depth + walkway) * m} L${screenWidth} ${(top.dim
                .depth +
                walkway) *
                m}`}
              className='svg-transition'
              style={{
                fill: 'none',
                stroke: 'black',
                strokeDasharray: 4
              }}
            />
            <g
              className='svg-transition'
              transform={`translate(0,${m *
                (top.dim.depth + walkway / 2 + door / 2)})`}
            >
              <line x1={-(door * m)} x2={0} y1={0} y2={0} />
              <path
                d={describeArc(0, 0, door * m, 270, 360)}
                style={{
                  fill: 'none',
                  stroke: 'black'
                }}
              />
            </g>
          </g>

          {Array.from(Array(top.count).keys()).map((d, i) => {
            const xAdj = (width - (top.count + 1) * top.dim.width) / 2;
            const x = (xAdj + top.dim.width + top.dim.width * i) * m;
            return (
              <SVGBlock
                bikeConfiguration={bikeConfiguration}
                key={'dd' + i + pseudoKey + svgRacks}
                dim={i === 0}
                w={width}
                file={top.productType}
                x={x}
                y={0}
                m={m}
                length={length}
                h={top.dim.depth}
                isSvg={svgRacks}
              />
            );
          })}
          {!isFields &&
            Array.from(Array(bottom.count).keys()).map((d, i) => {
              const xAdj = (width - (bottom.count + 1) * bottom.dim.width) / 2;

              const x = (xAdj + bottom.dim.width + bottom.dim.width * i) * m;
              const y = Math.floor((length - bottom.dim.depth) * m);

              return (
                <SVGBlock
                  bikeConfiguration={bikeConfiguration}
                  key={'ddf' + i + pseudoKey + svgRacks}
                  file={bottom.productType}
                  length={length}
                  x={x}
                  w={width}
                  y={y}
                  m={m}
                  flip={180}
                  h={bottom.dim.depth}
                  isSvg={svgRacks}
                />
              );
            })}
          {isFields &&
            Array.from(Array(fields.fields).keys()).map((d, i) => {
              let x =
                (fields.dim.depth / 2 +
                  fields.dim.depth * i +
                  walkway * Math.ceil(i / 2)) *
                m;
              if (i === fields.fields - 1 && fields.fields % 2 === 0) {
                x = screenWidth - (fields.dim.depth / 2) * m;
              } else if (i === fields.fields % 2 && i !== 0) {
                // const innerSpace = (length - walkway * 2 - fields.dim.depth * 2) * m
                // const innerFields = fields.fields - 2;
                // x = ((walkway + fields.dim.depth * 3 / 2) * m) + innerSpace / (innerFields + 1);
                // console.log(x)
              }
              let y = Math.floor(
                screenHeight -
                  (bottom.productType === 'VARSITY' ? 60 : fields.dim.margin) *
                    m
              );
              return (
                <g key={'dde' + i}>
                  {Array.from(Array(fields.count).keys()).map((e, j) => {
                    y -= j > 0 ? fields.dim.width * m : 0;
                    return (
                      <SVGBlock
                        bikeConfiguration={bikeConfiguration}
                        key={j + pseudoKey + svgRacks}
                        file={fields.productType}
                        length={length}
                        w={width}
                        x={x}
                        y={y}
                        m={m}
                        flip={i % 2 === 0 ? -90 : 90}
                        h={fields.dim.depth}
                        isSvg={svgRacks}
                      />
                    );
                  })}
                </g>
              );
            })}
        </svg>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Configuration/Render/SVG/index.js